export default __webpack_public_path__ + "static/media/stethoscope.cc13ef1c.png";